/* eslint-disable max-len */
import BlogImage1 from "assets/images/blog.image.1.png";
import BlogImage2 from "assets/images/blog.image.2.png";
import BlogImage3 from "assets/images/blog.image.3.png";

const MAIN_HEADINGS = {
	first: "Storage.com Help",
	second: "Check out some of our informative blog posts below."
};

const HELP_PAGE_DATA = [
	{
		title: "About Storage.com",
		desc: "Storage.com is a self-storage aggregation website and tool founded in 2010. As a network partner of US Storage Search, Storage.com provides information on the largest available variety of self-storage facilities and allows for online reservations through the website. Prospective self-storage customers, using Storage.com website, benefit from a simple and unbiased online shopping and comparison experience that is secure and easy to use."
	},
	{
		title: "Frequently Asked Questions",
		desc: "Reserving a self storage unit online can be a new experience for many people. Here are some frequently asked questions about self-storage reservations made through Storage.com."
	},
	{
		title: "How Do I Know My Reservation Is Confirmed?",
		descLinkMultiple: [
			{
				content:
					"When you have completed your online reservation, your confirmation number will be displayed on the confirmation page. If you completed your reservation by phone you will also receive a confirmation number. Additionally, we will send you an email confirmation after you've completed your booking. Please feel free to contact us by email at ",
				linkText: "customerhelp@storage.com",
				email: "customerhelp@storage.com"
			},
			{
				content: " or by phone at .",
				linkText: "(833) 448-1067",
				phone: {
					formattedNumber: "833-448-1067",
					number: "8334481067"
				}
			},
			{
				content: " if you have questions about your reservation"
			}
		]
	},
	{
		title: "How Do I Get A Receipt For My Reservation?",
		descLinkMultiple: [
			{
				content:
					"When you complete a reservation your receipt is displayed directly in your web browser as well as emailed to you. Please feel free to contact us by email at ",
				linkText: "customerhelp@storage.com",
				email: "customerhelp@storage.com"
			},
			{
				content: " or by phone at ",
				linkText: "(833) 448-1067",
				phone: {
					formattedNumber: "833-448-1067",
					number: "8334481067"
				}
			},
			{
				content: " if you need help locating a copy of your receipt."
			}
		]
	},
	{
		title: "What Is Your Cancellation Policy?",
		desc: "You can cancel your reservation any time prior to date you’ve selected as your move-in date on your reservation. Your reservation is directly forwarded to the self storage facility so to request a cancellation you’ll need to contact the self storage facility directly. Your confirmation email will have information to contact the facility as well as your confirmation number – these items will make your cancellation easy."
	},
	{
		title: "How Do I Modify My Reservation?",
		descLinkMultiple: [
			{
				content:
					"If you need to change any details about your reservation email us at ",
				linkText: "customerhelp@storage.com",
				email: "customerhelp@storage.com"
			},
			{
				content: " or by phone at ",
				linkText: "(833) 448-1067",
				phone: {
					formattedNumber: "833-448-1067",
					number: "8334481067"
				}
			}
		]
	},
	{
		title: "When Will I Be Charged For My Self Storage Rental?",
		desc: "Once you’ve completed a reservation through Storage.com your deposit will be charged and immediately transferred to the self storage facility where you’ve made a reservation. Any other charges such as a monthly rental or administration fee will not be charged until you complete the rental at your facility."
	}
];

const BLOG_POSTS_DATA = [
	{
		image: BlogImage1,
		imageAlt: "Blog Image 1",
		title: "Jet Ski Storage Tips",
		desc: "Jet skis are great fun for the summer, but need to be stored in cooler temperatures. Learn how to store your jet ski with preparations, features, and self storage.",
		link: "https://www.storage.com/blog/jet-ski-storage/ "
	},
	{
		image: BlogImage2,
		imageAlt: "Blog Image 2",
		title: "The Complete Guide to Vehicle Storage",
		desc: "Vehicle storage includes more than just your car. It’s also common for people to use self storage for their motorcycles, boats, ATVs, and any other sort of personal vehicle. Look no further, your ultimate resource guide to storing your vehicle is all right here.",
		link: "https://www.storage.com/blog/the-complete-guide-to-vehicle-storage/ "
	},
	{
		image: BlogImage3,
		imageAlt: "Blog Image 3",
		title: "Storing a Motorcycle in Self Storage",
		desc: "Running out of room in the garage for your motorcycle? Are you being deployed oversees for a while? Do you live in an area with snowy months? Whatever the case may be, storing your motorcycle in a storage unit is a helpful solution. Here is a detailed list that covers everything you need to know about motorcycle storage. ",
		link: "https://www.storage.com/blog/storing-a-motorcycle-self-storage/ "
	}
];

export { MAIN_HEADINGS, HELP_PAGE_DATA, BLOG_POSTS_DATA };
